import React from 'react';

import type { SmallBannerProps } from './types';
import { getBannerBackgroundSrc } from '../banner/utils';

import styles from './styles.module.scss';

export const SmallBanner = ({
  title,
  description,
  backgroundImageSrc,
  backgroundImageAlt = '',
}: SmallBannerProps): React.ReactElement => {
  const bgSrc = getBannerBackgroundSrc(backgroundImageSrc);

  return (
    <section className={styles.smallBanner} aria-label={title}>
      <div className={styles.background}>
        <img
          src={bgSrc}
          alt={backgroundImageAlt}
          className={styles.backgroundImage}
          loading="eager"
        />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
    </section>
  );
};
